import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { UserService } from '../../../../../../common/services/User.service';
import { GroupService } from '../../../../../../common/services/Group.service';
import { OrganizeService } from '../../../../../../common/services/Organize.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SocketService } from '../../../../../../common/services/Socket.service';
import { AgentConst } from './agent.const';
import { TableAction } from '../../../../../../components/table-component/table.const';
import { UtilityService } from '../../../../../../common/services/Utility.service';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import * as _ from 'lodash';
import { isEmail } from '../../../../../../common/utils/validate';
import * as moment from 'moment';

@Component({
  selector: 'app-agent',
  templateUrl: './agent.component.html',
  styleUrls: ['./agent.component.css'],
  providers: [UserService, GroupService, BsModalService, UtilityService],
})
export class AgentComponent extends BaseListComponent {
  public no_image = 'assets/images/contact.png';
  public total = 0;
  public modelFilter: any = {};
  public id_delete: any;
  public is_load_data = false;
  public allGroup: any = [];
  public allRole: any = [{ id: '', text: 'Vai trò' }, ...AgentConst.userRoleArray()];

  @ViewChild('templateUser') templateUser: ElementRef;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private userService: UserService,
    private groupService: GroupService,
    private socketService: SocketService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = AgentConst.displayColumns();
  }

  ngOnInit() {
    this.getGroup().then();
    this.loadData().then();
  }

  async loadData(request: any = {}, sort: any = {}) {
    const payload = await this.buildBasePayload(request, sort);
    this.userService.list(payload).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.data = res.data.list;
        this.data.map(r => {
          r.display_role = AgentConst.displayRoleColumns(r, this.user._id);
          r.display_active = AgentConst.displayActiveColumns(r);
          r.status = r.active;
          return r;
        });
        this.initPage(res.data.total);
      }
    });
  }

  async getGroup() {
    this.is_load_data = true;
    this.groupService.allGroup({ target: 'user' }).subscribe(res => {
      const groupList = [{ id: '', text: 'Bộ phận' }];
      res.data.forEach((c: any) => {
        groupList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allGroup = groupList;
      this.is_load_data = false;
    });
  }

  async search() {
    this.currentPage = 1;
    const filters = [];
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      const isnum = UtilityService.isValidPhoneNumber(this.modelFilter.keyword.trim());
      if (!isnum) {
        this.modelFilter.keyword
          .replace(/\s+/g, ' ')
          .trim()
          .split(' ')
          .forEach(element => {
            filters.push({
              key: 'name',
              condition: 'like',
              value: element.toLowerCase(),
            });
          });

        await this.loadData({ filters: JSON.stringify(filters) });
      } else {
        filters.push({
          key: 'phone',
          condition: '=',
          value: this.modelFilter.keyword.trim(),
        });
        await this.loadData({ filters: JSON.stringify(filters) });
      }
    } else {
      await this.loadData();
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    }
  }

  openUser(user) {
    this.socketService.opentab(user, 'user', 'edit');
  }

  async addUser() {
    let payload = {
      name: this.model.name,
      email: this.model.email,
      role: this.model.role,
      group_id: this.model.group_id,
    };

    this.userService.create(payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Thêm mới thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async active(id, status) {
    if (status === undefined || status === null) {
      status = true;
    }
    this.userService.active(id, { active: status }).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.is_loading = true;
          setTimeout(() => {
            this.data.map(r => {
              if (r._id === id) {
                r.status = status;
              }
              return r;
            });
            this.throwSuccess(status ? 'Kích hoạt thành công!' : 'Dừng hoạt động thành công!');
            this.is_loading = false;
          }, 1000);
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async setUpModel() {
    this.modelContent = {
      type: ModalType.Primary,
      title: 'Tạo mới chuyên viên',
      submit_title: 'Thêm mới',
    };
    this.modelDisplay = [
      {
        key: 'name',
        label: 'Tên chuyên viên',
        type: FormFieldType.Text,
        value: this.model.name,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
      {
        key: 'email',
        label: 'Email chuyên viên',
        type: FormFieldType.Text,
        value: this.model.email,
        required: true,
        disabled: false,
        width: 'full',
        order: 1,
      },
      {
        key: 'role',
        label: 'Vai trò',
        type: FormFieldType.Select2,
        value: this.model.role,
        required: true,
        disabled: false,
        width: 'full',
        order: 2,
        options: {
          data: this.allRole,
          select2Options: {
            placeholder: { id: '', text: 'Vai trò' },
          },
        },
      },
      {
        key: 'group_id',
        label: 'Bộ phận',
        type: FormFieldType.Select2,
        value: this.model.group_id,
        required: true,
        disabled: false,
        width: 'full',
        order: 4,
        options: {
          data: this.allGroup,
          select2Options: {
            placeholder: { id: '', text: 'Bộ phận' },
          },
        },
      },
    ];
  }

  async handleAction(type: any, item?: any) {
    switch (type) {
      case TableAction.add:
        const config = {
          backdrop: true,
          ignoreBackdropClick: true,
          keyboard: false,
          class: 'modal-md',
        };
        this.model = {
          dob: null,
        };
        await this.setUpModel();
        this.openModal(this.templateUser, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.edit:
        this.openUser(item);
        break;
      case TableAction.active:
        await this.active(item._id, item.status);
        break;
    }
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    await this.addUser();
  }

  async onChangeValueModel(key, item?: any) {
    this.model = _.merge({}, this.model, item);
    this.message = null;
    switch (key) {
      case 'email':
        if (!isEmail(this.model[key]) && item[key]) {
          this.message = {
            class: 'alert dark alert-danger',
            content: 'Email không đúng định dạng!',
          };
        }
        break;
    }
    await this.setUpModel();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/expert/agent/agent.component.ts